import Connection from './connection'
import Store from './store'

export default class ResellerTeamsStore extends Store {
  constructor(scope) {
    super(new Connection('reseller_teams', scope))
  }
}



// WEBPACK FOOTER //
// client/stores/reseller_teams.js